<template>
  <div>
    <Header modeType="2" />
    <div class="content-center">
      <div class="banner">
        <div class="content">
          <div class="banner-title">千橙微商城</div>
          <div class="line" />
          <div class="desc">
            一款为零售门店打造的专属小程序网店，帮助门店汇聚周边人气，链接周边3-5公里熟人社群，帮助门店实现销量提升
            <!-- <div class="desc-content">为企业提供业务员外勤管理、销售管理、订单管理、佣金管理、客户管理等销售辅助功能，全面提升销售业绩；基于企业微信，无缝对接企业商城、ERP、WMS、OMS等企业管理系统，构建全链路全闭环的数字化业务体系。</div> -->
          </div>
          <div class="btn-wrap">
            <div
                class="btn1"
                @click="openLoginModal"
              >免费试用</div>
            <div class="btn" @click="openModal">立即咨询</div>
          </div>
        </div>
      </div>
      
      <div class="improve1">
          <div class="sk-block-title1">
              <div class="title1">线上商城+社群营销互动  助力零售门店经营升级</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content">
  
          </div>
      </div>
      <div class="improve" style="height: 742px;">
          <div class="sk-block-title1">
              <div class="title1">更贴近社群场景的营销工具，把社群生意变的简单</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content">
            <div class="content_left">
                <div class="left_item" :class="{'left_item1':tooItem=='1'}" @click="checkBg('1')">
                    <img v-if="tooItem=='1'" src="@/assets/images/QcShoppingMall/left_item.png" alt="" />
                    <span>社群互动</span>
                </div>
                <div class="left_item" :class="{'left_item1':tooItem=='2'}" @click="checkBg('2')">
                    <img v-if="tooItem=='2'" src="@/assets/images/QcShoppingMall/left_item.png" alt="" />
                    <span>分销裂变</span>
                </div>
                <div class="left_item" :class="{'left_item1':tooItem=='3'}" @click="checkBg('3')">
                    <img v-if="tooItem=='3'" src="@/assets/images/QcShoppingMall/left_item.png" alt="" />
                    <span>销量提升</span>
                </div>
                <div class="left_item" :class="{'left_item1':tooItem=='4'}" @click="checkBg('4')">
                    <img v-if="tooItem=='4'" src="@/assets/images/QcShoppingMall/left_item.png" alt="" />
                    <span>留存复购</span>
                </div>
            </div>
            <div class="content_right">
                <img v-if="tooItem=='1'" src="@/assets/images/QcShoppingMall/content_right1.png" alt="">
                <img v-if="tooItem=='2'" src="@/assets/images/QcShoppingMall/content_right2.png" alt="">
                <img v-if="tooItem=='3'" style="width:801px;height:480px;" src="@/assets/images/QcShoppingMall/content_right3.png" alt="">
                <img v-if="tooItem=='4'" src="@/assets/images/QcShoppingMall/content_right4.png" alt="">
            </div>
          </div>
      </div>
      <div class="improve1" style="height: 668px;">
          <div class="sk-block-title1">
              <div class="title1">线上线下融合，优势互通促转化</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content1">
  
          </div>
      </div>
      <div class="sale">
        <div class="sk-block-title1">
              <div class="title1" style="color:#ffffff;">拓展更多经营场景，助力门店提升销售</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content">

          </div>
      </div>
      <div class="scence">
        <div class="sk-block-title1">
          <div class="title1">更多场景功能</div>
        </div>
        <div class="content"></div>

      </div>
      <div class="custom">
        <div class="sk-block-title1">
          <div class="title1">客户案例</div>
        </div>
        <div class="content">
          <el-carousel :autoplay="false" :interval="5000" arrow="always">
            <el-carousel-item >
            <div class="custom_item">
              <img src="@/assets/images/QcShoppingMall/custom_bg1.png" alt="">
            </div>
          </el-carousel-item>
          <el-carousel-item >
            <div class="custom_item">
              <img src="@/assets/images/QcShoppingMall/custom_bg2.png" alt="">
            </div>
          </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      
      <Contact :infoSources="'汇通数科官网-千橙微商城'"/>
      <TryModal
        v-if="visible"
        :visible="visible"
        info-sources="社群分销"
        @cancel="modalClose"
      />
      <LoginModal
            v-if="showLogin"
            :showLogin="showLogin"
            @cancel="loginModalClose"
            :isLogin="isLogin"
            :selectValue="'4'"
        />
    </div>
    <Footer />
  </div>
  </template>
  
  <script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import metaInfo from "@/common/util/metaInfo";
  import TryModal from "@/components/TryModal";
  import Contact from "@/components/Contact";
  import LoginModal from '@/components/LoginModal'

  export default {
    metaInfo: metaInfo.QcShoppingMall,
    components: {
      Header,
      Footer,
      TryModal,
      Contact,
    LoginModal
    },
    data() {
      return {
        visible: false,
        toolBg: require("@/assets/images/QcCashier/tool1.png"),
        tooItem: "1",
        showLogin:false,//是否展示注册弹框
      isLogin:false,//是否注册
      };
    },
    mounted() {},
    methods: {
        // 是否需要显示二维码
    openLoginModal() {
        this.showLogin = true
        this.isLogin = false
    },
    loginModalClose(data) {
        this.showLogin = data;
    },
      checkBg(item) {
        this.tooItem = item;
        this.toolBg = "@/assets/images/QcCashier/tool" + item + ".png";
      },
      openModal: function () {
        this.visible = true;
      },
      modalClose: function (data) {
        this.visible = data;
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .scence{
    height: 762px;
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items:center;
      .content{
          margin-top:10px;
          width: 1200px;
          height:640px;
          background: url("~@/assets/images/QcShoppingMall/content4.png") no-repeat center;
          background-size: 1200px 640px;
      }
  }
  .sale{
        height: 655px;
      background:  url("~@/assets/images/QcShoppingMall/content_banner.png") no-repeat center;
      background-size: 100% 655px;
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items:center;
      .content{
          margin-top:79px;
          width: 1200px;
          height:350px;
          background: url("~@/assets/images/QcShoppingMall/content3.png") no-repeat center;
          background-size: 1200px 350px;
      }
  }
  .improve1{
      height: 592px;
      background: #F8FAFD;
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items:center;
      .content{
          margin-top:6px;
          width: 1200px;
          height:476px;
          background: url("~@/assets/images/QcShoppingMall/content1.png") no-repeat center;
          background-size: 1200px 476px;
      }
      .content1{
          margin-top:50px;
          width: 1200px;
          height:448px;
          background: url("~@/assets/images/QcShoppingMall/content2.png") no-repeat center;
          background-size: 1200px 448px;
      }
      .shopkeeper_btn{
          height: 46px;
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items:center;
          .btn{
              width: 220px;
              height: 46px;
              background: #FFFFFF;
              border-radius: 30px;
              border: 1px solid #396FEB;
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #396FEB;
              line-height: 46px;
              text-align: center;
              margin-top: 40px;
          }
      }
  }
  .improve{
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items:center;
      .content{
          margin-top:40px;
          width: 1200px;
          height:544px;
          background: #FFFFFF;
          display: flex;
          flex-direction: row;
          .content_right{
            width: 831px;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                width: 668px;
                height:480px;
            }
          }
          .content_left{
            background: url("~@/assets/images/QcShoppingMall/content_left.png") no-repeat center;
            background-size: 369px 544px;
            width: 369px;
            display: flex;
            flex-direction: column;
            align-items: end;
            justify-content: center;
            .left_item{
                width: 320px;
                height: 126px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                img{
                    width: 10px;
                    height:28px;
                }
                span{
                    margin-left:16px;
                    width: 96px;
                    height: 33px;
                    font-size: 24px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    line-height: 33px;
                }
            }
            .left_item1{
                width: 320px;
                height: 126px;
                background: #FFFFFF;
                border-radius: 20px 0px 0px 20px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                img{
                    width: 10px;
                    height:28px;
                }
                span{
                    width: 128px;
                    height: 45px;
                    font-size: 32px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    color: #3986FF;
                    line-height: 45px;
                }
            }
          }
      }
      .content1{
          margin-top:50px;
          width: 1200px;
          height:581px;
          background: url("~@/assets/images/QcShopkeeper/improve.png") no-repeat center;
          background-size: 1200px 581px;
      }
      .content2{
          margin-top:40px;
          width: 1200px;
          height:400px;
          background: url("~@/assets/images/QcShopkeeper/improve.png") no-repeat center;
          background-size: 1200px 400px;
      }
  }
  .store{
          height:904px;
          background: url("~@/assets/images/QcShopkeeper/banner1.png") no-repeat center;
          background-size: 1920px 904px;
          background-color: #202239;
          display: flex;
          flex-direction: column;
          // justify-content: center;
          align-items:center;
          .store_title{ 
              width: 1030px;
              height: 117px;
              font-size: 36px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              color: #FFFFFF;
              line-height: 50px;
              margin-top:69px;
          }
          .store_box{
              width: 1200px;
              height: 160px;
              margin-top:511px;
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              justify-content: start;
              .box_item{
                  width: 200px;
                  height: 68px;
                  background: linear-gradient(97deg, #1F223B 0%, #354361 100%);
                  border-radius: 6px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  justify-content: center;
                  span{
                      width: 48px;
                      height: 22px;
                      font-size: 16px;
                      font-family: PingFangSC, PingFang SC;
                      font-weight: 500;
                      color: #FFFFFF;
                      line-height: 22px;
                      margin-left: 10px;
                  }
                  img{
                      width: 30px;
                      height: 30px;
                  }
              }
          }
  }
  /deep/ i.el-icon-arrow-left {
      font-size: 35px;
      font-weight: 600;
  }
  /deep/ i.el-icon-arrow-right{
      font-size: 35px;
      font-weight: 600;
  }
  /deep/ button.el-carousel__arrow.el-carousel__arrow--left,button.el-carousel__arrow.el-carousel__arrow--right {
      width: 50px;
      height: 86px;
      border-radius: 0px;
      background-color: rgba(0,0,0,.4);
  }
  /deep/ button.el-carousel__arrow.el-carousel__arrow--right {
      width: 50px;
      height: 86px;
      border-radius: 0px;
      background-color: rgba(0,0,0,.4);
  }
  
  .custom{
    height:662px;
        background: url("~@/assets/images/qcerpsystem/carousel_bg.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items:center;
    .content{
        width: 1200px;
        height:439px;
        margin: 0 auto;
        // padding: 53px 0;
        text-align: left;
        background: rgba(255,255,255,.5);
        // background: #FFFFFF;
        // opacity: 0.55;
        // border-radius: 8px;
        margin-top: 42px;
        /deep/ .el-carousel__container {
            position: relative;
            height: 439px;
        }
        .custom_item{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            // padding:0 150px;
            img{
                width: 1200px;
                height: 439px;
            }
        }
    }
}
  .case{
      background: #F8FBFF;
      .content{
          width: 1200px;
          margin: 0 auto;
          padding: 53px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
              width: 1171px;
              height:397px;
          }
      }
  }
  
    .banner {
      background: url("~@/assets/images/QcShoppingMall/banner.png") no-repeat center;
      background-size: 100% 100%;
      min-width: 1200px;
      min-height:420px;
      .content {
        width: 1200px;
        margin: 0 auto;
        padding: 53px 0;
        text-align: left;
        .banner-title {
          font-size: 48px;
          color: #FFFFFF;
          line-height: 55px;
        }
        .line {
          width: 100px;
          height: 6px;
          background: #28DAFB;
          margin: 16px 0 31px;
        }
        .desc {
          width: 600px;
          height: 101px;
          font-size: 20px;
          color: #FFFFFF;
          font-weight: normal;
          line-height: 28px;
          .desc-content{
              width: 600px;
              height: 96px;
              font-size: 16px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 32px;
          }
        }
        .btn-wrap {
          display: flex;
          .btn {
            width: 200px;
            height: 58px;
            line-height: 58px;
            border-radius: 6px;
            border: 1px solid #FFFFFF;
            font-size: 22px;
            color: #FFFFFF;
            cursor: pointer;
            text-align: center;
            margin-top: 47px;
            margin-left:20px;
          }
          .btn1 {
            width: 200px;
            height: 58px;
            line-height: 58px;
            background: #3986FF;
            border-radius: 6px;
            font-size: 22px;
            color: #FFFFFF;
            cursor: pointer;
            text-align: center;
            margin-top: 47px;
          //   margin-left:20px;
          }
        }
      
    }
  
  }
  </style>
  